import exchangeInfoTopCoins from '../widgets/exchangeInfoTopCoins.js';

(function ($) {
    $(async function () {
        window.$ = jQuery;
        await exchangeInfoTopCoins.updateDynamicsData();
    });
}(jQuery));